import { Moment } from "moment";

export default {
    normalizeIsoStrings: (s: Moment) => {
		return s.toISOString().replace(/-|:|\.\d\d\d/g, '');
	},
	getNumberOfHours: (time: number) => {
		return time / 60;
	}
}